import { Grid, Typography } from "@mui/material";

const ClientEndorsement = () => {
  return (
    <Grid container gap={2} alignItems="center">
      <Grid item>
        <Typography fontSize={"14px"} color={"#0F1829"}>
          Waiting for employer review
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ClientEndorsement;
